module.exports = __webpack_public_path__ + "img/4-2-1-5-2-preview-play_nomore-e.9ff8a6cf.jpg";